import useProducts from '@hooks/product/useProducts';
import { cTAClicked } from '@repo/ui/src/services/analytics';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import Product from '@models/product';

interface ShoppableIngredientProps {
  product: Product;
}

const ShoppableIngredient = ({ product }: ShoppableIngredientProps) => {
  const { products } = useProducts([product]);
  const [shoppableProduct] = products;
  const { push } = useModal(ModalID.learnMore);

  return (
    <td
      itemProp="recipeIngredient"
      className="tra-text-web-body-l tw-mb-0 tw-pl-2 tw-cursor-pointer"
    >
      <Button
        variant={ButtonVariant.bare}
        size="none"
        className="tw-text-brand-300 tw-underline hover:tw-underline tw-normal-case tra-text-web-body-l"
        onClick={() => {
          push(shoppableProduct);
          cTAClicked({ cta_text: shoppableProduct.title });
        }}
      >
        {shoppableProduct?.title}
      </Button>
    </td>
  );
};

export default ShoppableIngredient;
